export default __webpack_public_path__ + "static/media/2.13337696.jpg";